




















import Vue from 'vue';
export default Vue.extend({
  name: 'HMPagination',
  data() {
    return {
      currentPage: 1,
      perPage: 0,
      totalCount: 0,
    };
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    paginatedResponse: {
      type: Object as () => PaginatedResponse<any>,
    },
    limit: {
      type: Number,
      default: 9,
    },
  },
  mounted() {
    this.perPage = this.paginatedResponse.results.length;
    this.totalCount = this.paginatedResponse.count;
  },
  watch: {
    value: {
      handler(value: number) {
        this.currentPage = value;
      },
      immediate: true,
    },
    currentPage: {
      handler(value: number) {
        this.$emit('input', value);
      },
    },
  },
});
